import { Text } from '@chakra-ui/react'

const ID = ({id}:{id:number}) => {
  return (
    <Text>#{id}</Text>
  )
}

export default ID